import { render, staticRenderFns } from "./OrderUpdatePayment.vue?vue&type=template&id=f0c8037e"
import script from "./OrderUpdatePayment.vue?vue&type=script&lang=js"
export * from "./OrderUpdatePayment.vue?vue&type=script&lang=js"
import style0 from "./OrderUpdatePayment.vue?vue&type=style&index=0&id=f0c8037e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports